import FragmentDataType from "../enums/fragment-data-type";
import FootballState from "../state/football-state";
import Returned from "./returned";
import { FragmentMessages } from "../../common/fragment-messages";
import ReturnedByDefaultValue from "./default-value/returned-by-default-value";

export default class NoRecoveryKickReturn extends Returned {
    constructor(returnedBy, returnedAt) {
        super(returnedBy, returnedAt);

        this.requiredData = [
            {
                name: "returnedBy",
                type: FragmentDataType.Player,
                // appliesToOpponent: () => true,
                displayName: "Returned By",
                title: (team) => `Returned By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true,
                defaultValue: ({ play, summaryContext }) =>
                    new ReturnedByDefaultValue(
                        play,
                        this,
                        summaryContext
                    ).resolve()
            },
            {
                name: "returnedAt",
                type: FragmentDataType.FieldPosition,
                displayName: "At",
                title: "At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                requiredAfterNextState: [
                    FootballState.Tackle,
                    FootballState.OutOfBounds
                ],
                showEndZoneYards: (gameConfig) =>
                    gameConfig.general.includeEndZoneYardage
            }
        ];
    }
}
